export const images = [
  {
    url: "https://res.cloudinary.com/dni5cjwpu/image/upload/v1661305916/Pngtree_cartoon_couple_png_download_4748396_fpiff3.png",
  },
  {
    url: "https://res.cloudinary.com/dni5cjwpu/image/upload/v1661305915/kisspng-romance-animation-couple-romantic-couples-vector-5a94a77a6acce1.7040417315196916424375_oxjdjz.png",
  },
  {
    url: "https://res.cloudinary.com/dni5cjwpu/image/upload/v1661305914/kisspng-significant-other-download-vector-couple-5a8c16ff2582a6.3958547215191303671537_wxygbc.png",
  },
  {
    url: "https://res.cloudinary.com/dni5cjwpu/image/upload/v1661305907/kisspng-cartoon-illustration-loving-couple-holding-house-5a8ebbf70fbf92.6947806915193036710645_cj8fd0.png",
  },
  {
    url: "https://res.cloudinary.com/dni5cjwpu/image/upload/v1661305900/kisspng-clip-art-hand-painted-cartoon-couple-vector-image-5a9e066d55b960.8003358415203057733511_ppgaw8.png",
  },
];
